enum UserProgressStats {
  ACTIVITY = "activity",
  TRAINING = "training",
  WEEKLY_TRAINING = "weekly_training",
}

export default UserProgressStats;
